<template>
  <div
    :style="cellStyle"
    @mouseover="setFocusedTick(tick)"
    @mouseout="clearFocusedTick()">
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ReservationTableCell',
  props: {
    tick: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    pxPerCell: {
      type: Number,
      required: true,
    },
    borderColorDefault: {
      type: String,
      required: true,
    },
    backgroundColorFocused: {
      type: String,
      required: true,
    },
    tickBorderWidth: {
      type: Number,
      required: true,
    },
    borderTopWidth: {
      type: Number,
      required: true,
    },
    borderBottomWidth: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('reservation', ['focusedTick']),
    cellStyle () {
      let ret = {
        float: 'left',
        height: this.height + 'px',
        width: this.pxPerCell + 'px',
        'line-height': this.height + 'px',
        border: '0 solid ' + this.borderColorDefault,
        'border-left-style': this.tickBorderStyle,
        'border-left-width': this.tickBorderWidth + 'px',
        'border-top-width': this.borderTopWidth + 'px',
        'border-bottom-width': this.borderBottomWidth + 'px',
        'box-sizing': 'border-box',
      }
      if (this.tick.isSame(this.focusedTick)) {
        ret['background'] = this.backgroundColorFocused
      }
      return ret
    },
    tickBorderStyle () {
      if (this.tick.minutes() === 0) {
        return 'solid'
      } else if (this.tick.minutes() === 30) {
        return 'dashed'
      } else {
        return 'dotted'
      }
    },
  },
  methods: {
    ...mapActions('reservation', ['setFocusedTick', 'clearFocusedTick']),
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Table/Cell.vue